<template>
  <div
    class="moreSchedule"
    :class="[isHistory ? 'isHistory' : '']"
  >
    <div class="result-module">
      <section>
        <header>
          <titleBar title="战队赛程" />
        </header>
        <div class="list">
          <template v-if="scheduleList.length > 0">
            <!-- 不是历史赛季也不是春季赛，是历史赛季但不是春季赛 -->
            <!-- 2024冬季赛页面赛程顺序按照接口返回顺序渲染，前端不再排序 -->
            <template  v-if="this.newSeason">
              <div class="item" v-for="(itemEx, index) in scheduleListNew" :key="index">
                <div class="game-title" @click="toggleSchedule(index)">
                  <span>{{itemEx[0].schedule_name}}</span>
                  <span class="arrow" :class="{ 'arrow-up': expandedSchedules[index], 'arrow-down': !expandedSchedules[index] }"></span>
                </div>
                <transition name="slide">
                  <div v-if="expandedSchedules[index]" class="schedule-items">
                    <div v-for="(item, itemIndex) in itemEx" :key="itemIndex" class="item">
                      <schedule
                        :padTeamId="padTeamId"
                        :scheduleData="item"
                        :isMoreSchedule="true"
                        :gameType="item.gameType"
                      />
                    </div>
                  </div>
                </transition>
              </div>
            </template>
            <template v-if="!this.newSeason">
              <template v-if="list6?.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">战队联赛</div>
                <div class="item" v-for="(item, index) in list6" :key="index+'zdls'">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="7"
                  />
                </div>
              </template>
              <template v-if="list5?.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">巅峰赛</div>
                <div class="item" v-for="(item, index) in list5" :key="index">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="5"
                  />
                </div>
              </template>
              <template v-if="list4?.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">竞技场</div>
                <div class="item" v-for="(item, index) in list4" :key="index+'jjc'">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="6"
                    :newSeason="newSeason"
                  />
                </div>
              </template>
              <template v-if="list3.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">全国大赛</div>
                <div class="item" v-for="(item, index) in list3" :key="index">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="3"
                  />
                </div>
              </template>
              <template v-if="list2.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">精英争霸赛</div>
                <div class="item" v-for="(item, index) in list2" :key="index">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="2"
                  />
                </div>
              </template>
              <template v-if="list1.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">全网大乱斗</div>
                <div class="item" v-for="(item, index) in list1" :key="index+'dld'">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="1"
                    :newSeason="newSeason"
                  />
                </div>
              </template>
              <template v-if="list7?.length > 0">
                <!-- 夏季赛的全部赛程和秋季赛的历史记录 -->
                <div class="game-title">热身赛</div>
                <div class="item" v-for="(item, index) in list7" :key="index+'rss'">
                  <schedule
                    :padTeamId="padTeamId"
                    :scheduleData="item"
                    :isMoreSchedule="true"
                    :gameType="8"
                  />
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <p class="noData">查无数据</p>
          </template>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import Schedule from "@views/WinterGame/components/schedule.vue";
import titleBar from "@views/WinterGame/components/titleBar.vue";
import { serviceCenterTeamSchedule } from "@/api/winterGame";
import { getGameType } from "@/util/util";
import { Toast } from "vant";
export default {
  components: {
    titleBar,
    Schedule,
  },
  data() {
    return {
      currentCampusId: 88,
      currentUserId: 98,
      isHistory: false,
      scheduleId: "",
      seasonId: "",
      padTeamId: 0,
      scheduleList: [],
      // historyTime: "",
      teamInfo: null,
      newSeason: false,
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      scheduleListNew: [],
      expandedSchedules: []
    };
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯";
    this.initTeamInfo();
  },
  mounted() {
    // 历史赛季会携带路由会携带seasonId，2024秋季赛
    if (!this.$route.query.seasonId || this.$route.query.seasonId.indexOf('s.24.dongji') > -1 ) {
      this.newSeason = true;
    } else {
      this.newSeason = false;
    }
    if (this.$route.query.isHistory == 1) {
      this.isHistory = true;
      this.scheduleId = this.$route.query.scheduleId;
      this.seasonId = this.$route.query.seasonId;
    }
    this.setUserInfo();
    if (this.currentUserId) {
      this.serviceCenterTeamSchedule();
    }
  },
  methods: {
    getDay() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
      var day = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
      return year + "" + month + "" + day;
    },
    initTeamInfo2() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
      this.padTeamId = teamInfo.padTeamId;
    },
    initTeamInfo() {
      let teamInfoKey = "teamInfo";
      if (this.isHistory) {
        teamInfoKey = "historyTeamInfo";
      }
      let teamInfo = localStorage.getItem(teamInfoKey);
      this.teamInfo = JSON.parse(teamInfo);
      this.padTeamId = teamInfo.padTeamId;
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentUserId = userInfoId.agentUserId;
        this.currentCampusId = userInfoId.campusId;
        this.initTeamInfo();
      } else {
        Toast("找不到参赛信息");
      }
    },
    // 按照 status 字段进行排序
    sortAllData(a, b) {
      if (a.status === 1 && b.status !== 1) {
        return -1;
      }
      if (a.status !== 1 && b.status === 1) {
        return 1;
      }
      if (a.status === 0 && b.status === 2) {
        return -1;
      }
      if (a.status === 2 && b.status === 0) {
        return 1;
      }
      return 0;
    },
    sortByTime(a, b) {
      let aTime = new Date(a.section_start_date).getTime();
      let bTime = new Date(b.section_start_date).getTime();
      if (aTime > bTime) {
        return -1;
      } else if (aTime < bTime) {
        return 1;
      } else {
        return 0;
      }
    },
    sortAscByTime(a, b) {
      let aTime = new Date(a.section_start_date).getTime();
      let bTime = new Date(b.section_start_date).getTime();
      if (aTime < bTime) {
        return -1;
      } else if (aTime > bTime) {
        return 1;
      } else {
        return 0;
      }
    },
    async serviceCenterTeamSchedule() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          padTeamId: "",
          scheduleId: this.scheduleId,
          seasonId: this.seasonId,
        },
      };
      let res = await serviceCenterTeamSchedule(params);
      if (res.code == 0) {
        let resultList = res.data.map((item) => {
          let real_section_start_date = item.section_start_date;
          let startDateArr = item.section_start_date.split(" ");
          if (Array.isArray(startDateArr)) {
            item.section_start_date = startDateArr[0];
          }
          return {
            ...item,
            start_date: item.section_start_date,
            end_date: item.section_end_date,
            ware_zone_a: item.war_zone,
            team_id_a: item.team_id,
            team_id_b: item.vs_team_id,
            status_a: item.pk_result_a,
            status_b: item.pk_result_b,
            game_status: item.status,
            real_section_start_date: real_section_start_date,
          };
        });
        // 2024冬季赛大乱斗和竞技场需要筛选不大于当前日期的数据
        this.scheduleListNew = resultList;
        let currentDay = this.getDay()
        console.log('过滤前的数据数量:', this.scheduleListNew.length);
        console.log('当前日期:', currentDay);
        console.log('过滤后的数据数量:', this.scheduleListNew.length);
        
        // 一维数组转二维数组
        this.scheduleListNew = Object.values(this.scheduleListNew.reduce((res,item) => {
          res[item.schedule_name] ? res[item.schedule_name].push(item) : res[item.schedule_name] = [item];
          return res;
        },{}))
        
        console.log('分组后的数据:', this.scheduleListNew);
        console.log('每个分组的数据数量:', this.scheduleListNew.map(group => group.length));
        
        // 添加赛程类型
        this.scheduleListNew.forEach((e) => {
          e.forEach((i)=>{
            const gameTypeNew = getGameType(i.schedule_tag_id);
            i.gameType = gameTypeNew;
          }) 
        })
        
        // 初始化展开状态，默认展开所有赛程
        this.expandedSchedules = new Array(this.scheduleListNew.length).fill(true);
        
        // 调试信息
        console.log('scheduleListNew:', this.scheduleListNew);
        console.log('expandedSchedules:', this.expandedSchedules);
        
        this.scheduleList = resultList;
        this.scheduleList.forEach((e) => {
          const gameType = getGameType(e.schedule_tag_id);
          let currentDay = this.getDay()
          // 2024冬季赛大乱斗和竞技场需要筛选不大于当前日期的数据
          if (gameType === 1) {
            this.list1.push(e);
          } else if (gameType === 2) {
            this.list2.push(e);
          } else if (gameType === 3) {
            //全国大赛小组赛
            this.list3.push(e);
          } else if (gameType === 4) {
            //全国大赛淘汰赛
            this.list3.push(e);
          } else if (gameType === 6) {
            this.list4.push(e);
          } else if (gameType === 5) {
            this.list5.push(e);
          } else if (gameType === 7) {
            this.list6.push(e);
          } else if (gameType === 8) {
            this.list7.push(e);
          }
        });
        console.log('原有逻辑赛程需要排序');
        //先根据时间
        this.list1.sort(this.sortByTime);
        this.list2.sort(this.sortByTime);
        this.list3.sort(this.sortByTime);
        this.list4?.sort(this.sortByTime);
        this.list5?.sort(this.sortByTime);
        this.list6?.sort(this.sortAscByTime);
        //再根据开始结束状态
        this.list1.sort(this.sortAllData);
        this.list2.sort(this.sortAllData);
        this.list3.sort(this.sortAllData);
        this.list4?.sort(this.sortAllData);
        this.list5?.sort(this.sortAllData);
        this.list6?.sort(this.sortAllData);
      } else {
        Toast(res.message);
      }
    },
    toggleSchedule(index) {
      this.$set(this.expandedSchedules, index, !this.expandedSchedules[index]);
    },
  },
};
</script>

<style lang="less" scoped>
.moreSchedule {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 32px;
  min-height: 100vh;
  .noData {
    text-align: center;
    color: #ffffff;
    font-size: 32px;
  }
  .springBanner {
    img {
      width: 100%;
    }
  }

  .result-module {
    section {
      margin-bottom: 40px;
      .game-title {
        width: 100%;
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #323232;
        line-height: 44px;
        text-align: center;
        margin: 30px 0 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        transition: all 0.3s ease;
        
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        .arrow {
          margin-left: 8px;
          width: 0;
          height: 0;
          border-left: 12px solid transparent;
          border-right: 12px solid transparent;
          border-top: 16px solid #58ABF6;
          border-bottom: 0 solid transparent;
          transition: border 0.3s;
          &.arrow-up {
            border-top: 0 solid transparent;
            border-bottom: 16px solid #58ABF6;
          }
        }
      }
    }
    .item,
    header {
      margin-bottom: 16px;
    }
  }
}

// 过渡动画样式
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
}

.slide-enter-to, .slide-leave {
  max-height: 1000px;
  opacity: 1;
}
</style>
